import { combineReducers } from 'redux';
import authReducer from './backendAuth';
import callReducer from './backendCall';
import asrReducer from './backendAsr';
import mainReducer from './backendMain';
import configReducer from './backendConfig';
import commonReducer from './backendCommon';
import snoozeReducer from './backendSnooze';

const backgroundSlice = combineReducers({
    asr: asrReducer,
    auth: authReducer,
    call: callReducer,
    main: mainReducer,
    config: configReducer,
    common: commonReducer,
    snooze: snoozeReducer
});

export default backgroundSlice;
